__turbopack_context__.v({
  "containerL": "ContainerL-module__KhMHFW__containerL",
});
